import styled from "@emotion/styled";
import React, { FC } from "react";
import ReactPlayer from "react-player/vimeo";

import { usePageTracking } from "hooks";

import { PageContent } from "./PageContent";
import { PageHeader } from "./PageHeader";

const WebinarsContainer = styled(PageContent)`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`;

const VideoContainer = styled.div`
  margin: 1rem 1rem 4rem 1rem;
  width: 512px;
  height: 288px;
`;

const VideoTitle = styled.h3`
  margin: 1rem 0 0 1.5rem;
`;

const videos = [
  {
    title: "Extract Special Generator Trip Tables",
    // File name: Meet Up 2023 11 08 (Public)
    url: "https://vimeo.com/990032442/06ef438db5",
  },
  {
    title: "Methods and Validations",
    url: "https://vimeo.com/990031954/9b204ed98d",
  },
  {
    title: "2024 Features Announcement",
    url: "https://vimeo.com/990032872/56efe2200b",
  },
  {
    title: "Corridor Discovery",
    url: "https://vimeo.com/990035684/a16480149f",
  },
  {
    title: "Select Link",
    url: "https://vimeo.com/990035055/9d8556a02b",
  },
];

export const Webinars: FC = () => {
  usePageTracking();

  return (
    <>
      <PageHeader title="OpenPaths Patterns: Webinars" subtitle="Learn more about OpenPaths Patterns" />
      <WebinarsContainer>
        {videos.map(({ title, url }, index) => (
          <VideoContainer key={index}>
            <ReactPlayer title={title} url={url} controls width="100%" height="100%" />
            <VideoTitle>{title}</VideoTitle>
          </VideoContainer>
        ))}
      </WebinarsContainer>
    </>
  );
};
